export const handleSetData = (value) => (dispatch) => {
  dispatch({ type: "SET_DATA", payload: value });
};

export const handleShowAdd =
  (value, name = null) =>
  (dispatch) => {
    window.scrollTo(0, 0);
    dispatch({ type: "SHOW_ADD_MODAL", payload: { add: value, name } });
  };

export const handleShowEdit =
  (value = true, id = null, name = null) =>
  (dispatch) => {
    window.scrollTo(0, 0);

    dispatch({
      type: "SHOW_EDIT_MODAL",
      payload: value
        ? { id, edit: true, name }
        : { id: null, edit: false, name: null },
    });
  };

export const handleShowDetail =
  (value = true, id = null, name = null, data = null) =>
  (dispatch) => {
    window.scrollTo(0, 0);
    dispatch({
      type: "SHOW_DETAIL_MODAL",
      payload: { id, detail: value, name, data },
    });
  };

export const handleShowMore =
  (value = true, data = null) =>
  (dispatch) => {
    window.scrollTo(0, 0);
    console.log("MASUK");
    dispatch({
      type: "SHOW_MORE",
      payload: { value, data },
    });
  };

export const handleShowAdditional =
  (value = true, id = null, data = null) =>
  (dispatch) => {
    window.scrollTo(0, 0);
    dispatch({
      type: "SHOW_ADDITIONAL_MODAL",
      payload: { id, additional: value, data },
    });
  };

export const handleShowApproval =
  (value = true, actionType = null, data = null, roleName = "", url = "") =>
  (dispatch) => {
    dispatch({
      type: "SHOW_APPROVAL",
      payload: { value, actionType, data, roleName, url },
    });
  };

export const handleSetApproval = (data) => (dispatch) => {
  dispatch({
    type: "SET_APPROVAL_DATA",
    payload: data,
  });
};

export const handleResetModal = () => (dispatch) => {
  dispatch({ type: "RESET_MODAL" });
};
